import React from 'react';
import { Link } from 'react-router-dom';
import './CompanionCare.css';

function CompanionCare() {
  return (
    <div className="companion-care-page">
      {/* Header/Navigation */}
      <header className="header">
        <nav className="navbar">
          <div className="logo">
            <Link to="/"><h1>Malach <span>Healthcare</span></h1></Link>
          </div>
          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/#services">Services</Link></li>
            <li><Link to="/#contact">Contact</Link></li>
          </ul>
          <Link to="/#contact" className="btn btn-primary">Book Consultation</Link>
        </nav>
      </header>

      {/* Hero Section */}
      <section className="service-hero companion-hero">
        <div className="service-hero-content">
          <h1>Compassionate Companion Care That Feels Like Family</h1>
          <p>Connection, comfort, and care—because no one should ever feel alone</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-intro">
          <p className="intro-highlight">
            Caring for a loved one is an act of deep love—but it can also be exhausting, emotional, 
            and overwhelming. At Malach Healthcare, we understand that families don't just need help 
            with tasks; they need peace of mind, trust, and the comfort of knowing their loved one is never alone.
          </p>
          <p>
            Our companion care services are designed to support both your loved one and your family—filling 
            the gaps where care, connection, and reassurance matter most.
          </p>
        </div>

        <div className="needs-section">
          <h2>When Your Loved One Needs More Than Just Assistance</h2>
          <p>
            Loneliness, isolation, and lack of daily companionship can quietly affect health, mood, 
            and overall well-being. Even when medical needs are minimal, emotional and social needs 
            are just as important.
          </p>
        </div>

        <div className="services-list">
          <h2>Malach Healthcare's Companion Caregivers Provide</h2>
          <div className="services-grid-detail">
            <div className="service-item">
              <div className="service-item-icon">💝</div>
              <h3>Warm Companionship</h3>
              <p>Warm, consistent companionship that brightens every day</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">💬</div>
              <h3>Emotional Support</h3>
              <p>Emotional support and meaningful conversation</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🤝</div>
              <h3>Gentle Assistance</h3>
              <p>Gentle assistance with everyday routines</p>
            </div>
            <div className="service-item">
              <div className="service-item-icon">🛡️</div>
              <h3>Reassuring Presence</h3>
              <p>A reassuring presence that promotes safety and confidence</p>
            </div>
          </div>
          <p className="services-note">
            We focus on the person, not just the schedule.
          </p>
        </div>

        <div className="family-concerns">
          <div className="concerns-container">
            <div className="concerns-left">
              <h2>We Know Families Often Worry About</h2>
              <ul>
                <li>Safety when no one is home</li>
                <li>Loneliness or depression</li>
                <li>Declining motivation or engagement</li>
                <li>Balancing caregiving with work and life</li>
              </ul>
            </div>
            <div className="concerns-right">
              <h2>Our Companion Care Helps By</h2>
              <ul>
                <li>Offering dependable supervision and social interaction</li>
                <li>Encouraging independence while preventing isolation</li>
                <li>Supporting daily activities such as meals, light housekeeping, and errands</li>
                <li>Giving family caregivers time to rest, recharge, and be present as family—not just caregivers</li>
              </ul>
            </div>
          </div>
          <p className="support-message">You don't have to do this alone.</p>
        </div>

        <div className="caregivers-section">
          <h2>Caregivers Chosen for Kindness</h2>
          <p>
            At Malach Healthcare, our caregivers are chosen not only for their skills, but for their 
            kindness. We carefully match companions to each individual's personality, preferences, and 
            cultural values, creating genuine relationships built on trust and respect.
          </p>
          <p className="caregiver-promise">
            We treat your loved one as we would our own—with dignity, patience, and kindness.
          </p>
        </div>

        <div className="choice-section">
          <h2>A Choice to Share the Journey</h2>
          <p>
            Choosing companion care isn't about giving up responsibility—it's about sharing it. It's 
            about ensuring your loved one feels supported, valued, and connected, even when you can't 
            be there every moment.
          </p>
        </div>

        <div className="closing-message">
          <p className="highlight">
            Let Malach Healthcare walk beside your family with compassionate companion care that truly 
            fills the need for connection, comfort, and care.
          </p>
          <p className="tagline">
            Because no one should ever feel alone—and no family should carry the journey by themselves.
          </p>
          <Link to="/#contact" className="btn btn-primary btn-large">Book A Free Consultation</Link>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>Malach <span>Healthcare</span></h3>
            <p>Empowering golden years with compassionate care.</p>
            <div className="social-links">
              <a href="#facebook">📘</a>
              <a href="#twitter">🐦</a>
              <a href="#instagram">📷</a>
              <a href="#linkedin">💼</a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
                <li><Link to="/#services">Services</Link></li>
              <li><Link to="/#contact">Contact</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Our Services</h4>
            <ul>
              <li><Link to="/personal-care">Personal Care</Link></li>
              <li><Link to="/companion-care">Companion Care</Link></li>
              <li><Link to="/#services">Dementia Care</Link></li>
              <li><Link to="/specialty-care">Specialty Care</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>📍 740 Main St<br />Waltham, MA 02451</p>
            <p>📞 (781) 697-6330</p>
            <p>✉️ info@malachhealthcare.com</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>Copyright © 2025 | All Rights Reserved | Malach Healthcare</p>
        </div>
      </footer>
    </div>
  );
}

export default CompanionCare;
